















































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { tipoPartoStrings } from '../../utils/constants';

import { Exame } from '../../../../back/src/entity/Exame';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { GrupoExame } from '../../../../back/src/entity/GrupoExame';
import { TipoParto, StatusExame } from '../../../../back/src/types';

import CustomDialog from '../CustomDialog.vue';
import ResultadosDeExamesFormNovo from './ResultadosDeExamesFormNovo.vue';
import ResultadosDeExamesFormPedido from './ResultadosDeExamesFormPedido.vue';
import ResultadosDeExamesTabela from './ResultadosDeExamesTabela.vue';
import ResultadosDeExamesTabelaPedidos from './ResultadosDeExamesTabelaPedidos.vue';
import ResultadosDeExamesRemovidos from './ResultadosDeExamesRemovidos.vue';

export default Vue.extend({
  name: 'ResultadosDeExamesCollapse',
  components: {
    CustomDialog,
    ResultadosDeExamesFormNovo,
    ResultadosDeExamesFormPedido,
    ResultadosDeExamesTabela,
    ResultadosDeExamesTabelaPedidos,
    ResultadosDeExamesRemovidos,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    gestacao: {
      type: null || Object as () => Gestacao,
    },
    resultadosDeExames: {
      type: Array as () => ResultadoDeExame[],
    },
    resultadosDeExamesRemovidos: {
      type: Array as () => ResultadoDeExame[],
    },
    exames: {
      type: Array as () => Exame[],
    },
    gruposExames: {
      type: Array as () => GrupoExame[],
    },
  },
  data() {
    return {
      showResultadosDeExames: false,
      dialogResultadosDeExamesRemovidos: false,
      dialogResultadoDeExameNovo: false,
      dialogResultadoDeExamePedido: false,
    };
  },
  computed: {
    resultadosDeExamesSolicitados(): ResultadoDeExame[] {
      return _.filter(
        this.resultadosDeExames as ResultadoDeExame[],
        resultado => (resultado.status === StatusExame.S),
      );
    },
    resultadosDeExamesRealizados(): ResultadoDeExame[] {
      return _.filter(
        this.resultadosDeExames as ResultadoDeExame[],
        resultado => (resultado.status !== StatusExame.S),
      );
    },
    atual(): boolean {
      return (this.gestacao
        && this.paciente
        && this.paciente.gestacao_atual
        && this.gestacao.id === this.paciente.gestacao_atual.id
      );
    },
    titulo(): string {
      if (!this.gestacao) {
        return 'Exames sem gestação associada';
      }
      if (this.atual) {
        return 'Exames da gestação atual';
      }
      const momentDataParto = moment(this.gestacao.parto.data_parto);
      const dataParto = momentDataParto.isValid() ? momentDataParto.format('DD/MM/YYYY') : '';
      const tipoParto = _.has(tipoPartoStrings, this.gestacao.tipo_parto)
        ? ` - ${tipoPartoStrings[this.gestacao.tipo_parto]}`
        : '';
      let nomeBebes = '';
      if (this.gestacao.tipo_parto === TipoParto.N || this.gestacao.tipo_parto === TipoParto.C) {
        nomeBebes = ` - ${this.gestacao.nome1}${this.gestacao.nome2 ? ` & ${this.gestacao.nome2}` : ''}`;
      }
      return `Exames da gestação anterior (${dataParto}${tipoParto}${nomeBebes})`;
    },
  },
  mounted() {
    if (this.paciente.gestacao_atual) {
      this.showResultadosDeExames = this.atual;
    } else {
      this.showResultadosDeExames = this.gestacao === null;
    }
  },
  methods: {
    routeResultadosDeExamesNovo(gestacaoId: number) {
      return {
        name: 'ResultadosDeExamesNovo',
        params: {
          pacienteId: this.paciente.id,
          gestacaoId,
        },
      };
    },
    novoResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.$emit('novoResultadoDeExame', resultadoDeExame);
      this.dialogResultadoDeExameNovo = false;
      this.dialogResultadoDeExamePedido = false;
    },
    atualizaResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.$emit('atualizaResultadoDeExame', resultadoDeExame);
    },
    tableRowClass(status) {
      if (status === StatusExame.I) {
        return 'primary lighten-4 primary--text';
      }
      if (status === StatusExame.A || status === StatusExame['+']) {
        return 'error lighten-4 error--text';
      }
      if (status === StatusExame.N || status === StatusExame['-']) {
        return 'success lighten-4 success--text';
      }
      return 'text--disabled';
    },
  },
});
